import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsAccountSecurityPage } from './account/security/account-security.page';
import { AddEditWorkgroupComponent } from './add-edit-workgroup/add-edit-workgroup.component';
import { MemberListComponent } from './add-edit-workgroup/memberlist/memberlist.component';
import { MemberListItemComponent } from './add-edit-workgroup/memberlist/memberlistitem/memberlistitem.component';
import { AddUserModal } from '../../modals/add-user/add-user.modal';
import { DeleteMemberWorkgroupComponent } from './add-edit-workgroup/delete-member-workgroup/delete-member-workgroup.component';
import { DeleteUserModal } from './delete-user/delete-user.modal';
import { DeleteWorkgroupModal } from './organisation/workgroups/delete-workgroup/delete-workgroup.modal';
import { SettingsProgressBlockComponent } from './components/progress-block/settings-progress-block.component';
import { SettingsOrganisationUsersPage } from './organisation/users/settings-organisation-users.page';
import { UserListComponent } from './organisation/users/userlist/userlist.component';
import { UserListItemComponent } from './organisation/users/userlist/userlistitem/userlistitem.component';
import { SettingsOrganisationWorkgroupsPage } from './organisation/workgroups/settings-organisation-workgroups.page';
import { WorkgroupListComponent } from './organisation/workgroups/workgrouplist/workgrouplist.component';
import { WorkgroupListItemComponent } from './organisation/workgroups/workgrouplist/workgrouplistitem/workgrouplistitem.component';
import { SettingsNavigationComponent } from './settings-navigation/settings-navigation.component';
import { SettingsSubheaderComponent } from './settings-subheader/settings-subheader.component';
import { SettingsLayout } from './settings.layout';
import { UserSignatureComponent } from './components/user-signature.component';
import { StationeryListItemComponent } from './application/documents/stationery-list/stationery-list-item/stationery-list-item.component';
import { StationeryListComponent } from './application/documents/stationery-list/stationery-list.component';
import { DocumentsPage } from './application/documents/documents.page';
import { EnableAuthenticatorAppDialogComponent } from './account/security/enable-authenticator-app-dialog/enable-authenticator-app-dialog.component';
import { EnableAuthenticatorAppInfoComponent } from './account/security/enable-authenticator-app-dialog/enable-authenticator-app-info/enable-authenticator-app-info.component';
import { EnableAuthenticatorAppQrComponent } from './account/security/enable-authenticator-app-dialog/enable-authenticator-app-qr/enable-authenticator-app-qr.component';
import { EnableAuthenticatorAppRecoveryCodeComponent } from './account/security/enable-authenticator-app-dialog/enable-authenticator-app-recovery-code/enable-authenticator-app-recovery-code.component';
import { EnableSecurityKeyDialogComponent } from './account/security/enable-security-key-dialog/enable-security-key-dialog.component';
import { EnableSecurityKeyInfoComponent } from './account/security/enable-security-key-dialog/enable-security-key-info/enable-security-key-info.component';
import { EnableSecurityKeyReadyComponent } from './account/security/enable-security-key-dialog/enable-security-key-ready/enable-security-key-ready.component';
import { DisableDialogComponent } from './account/security/disable-dialog/disable-dialog.component';
import { EditOrganisationModal } from './edit-organisation/edit-organisation.modal';
import { PlatformAPISettingComponent } from './integrations/platformapi/platformapi-setting/platformapi-setting.component';
import { ClientOnlineComponent } from './integrations/documents/client-online/client-online.component';
import { OtherComponent } from './integrations/documents/other/other.component';
import { DigipoortComponent } from './integrations/services/digipoort/digipoort.component';
import { SBRNexusComponent } from './integrations/services/sbrnexus/sbrnexus.component';
import { CreditsNotificationComponent } from './components/credits-notification/credits-notification.component';
import { EmailPage } from './application/email/email.page';
import { LocationListItemComponent } from './application/signing/location-list/location-list-item/location-list-item.component';
import { LocationListComponent } from './application/signing/location-list/location-list.component';
import { ReasonListItemComponent } from './application/signing/reason-list/reason-list-item/reason-list-item.component';
import { ReasonListComponent } from './application/signing/reason-list/reason-list.component';
import { SigningPage } from './application/signing/signing.page';
import { ClientOnlineSettingsComponent } from './integrations/documents/client-online/client-online-settings/client-online-settings.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AuthModule, OpenIdConfiguration, StsConfigHttpLoader, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { QRCodeModule } from 'angularx-qrcode';
import { AppComponent } from '../app/app.component';
import { OpenIdConfigService } from '../../services/openidconfig.service';
import { isObservable, Observable } from 'rxjs';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from '../../modules/shared/shared.module';
import { SettingsAccountSecurityWebauthnListComponent } from 'src/app/components/settings/account/security/webauthn-list/settings-account-security-webauthn-list.component';
import { SettingsAccountSecurityWebauthnListitemComponent } from 'src/app/components/settings/account/security/webauthn-list/webauthn-listitem/settings-account-security-webauthn-listitem.component';
import { BrandingDisableModal } from 'src/app/components/settings/components/branding-disable/branding-disable.modal';
import { BrandingTabInfoComponent } from 'src/app/components/settings/components/branding-tab-info/branding-tab-info.component';
import { AddAzureBlobstorageModal } from 'src/app/components/settings/components/addAzureBlobstorage/addAzureBlobstorage.modal';
import { DisableAzureBlobstorageModal } from 'src/app/components/settings/components/disableAzureBlobstorage/disableAzureBlobstorage.modal';
import { PrivateWhatsappModal } from 'src/app/components/settings/components/branding-editWhatsapp/branding-editWhatsapp.modal';
import { GeneralPage } from 'src/app/components/settings/security/general/general.page';
import { IdentityPage } from 'src/app/components/settings/security/identity/identity.page';
import { SsoPage } from 'src/app/components/settings/security/sso/sso.page';
import { ValidationPage } from 'src/app/components/settings/security/validation/validation.page';
import { AddCreditsModal } from 'src/app/modals/add-credits/add-credits.modal';
import { DeleteCreditsModal } from 'src/app/components/settings/components/delete-credits/delete-credits.modal';
import { OrganisationListComponent } from 'src/app/components/settings/whitelabel/organisations/organisationlist/organisationlist.component';
import { OrganisationListItemComponent } from 'src/app/components/settings/whitelabel/organisations/organisationlist/organisationlistitem/organisationlistitem.component';
import { DeleteOrganisationModal } from 'src/app/components/settings/delete-organisation/delete-organisation.modal';
import { PlatformAPIModal } from 'src/app/components/settings/integrations/platformapi/platformapi-setting/platformapi-modal/platformapi.modal';
import { SimplicateModal } from 'src/app/components/settings/integrations/addressbook/simplicate-modal/simplicate-modal.component';
import { ConfigSalesforceModal } from 'src/app/components/settings/integrations/addressbook/config-salesforce-modal/config-salesforce-modal.component';
import { DigipoortModal } from 'src/app/components/settings/integrations/services/digipoort-modal/digipoort-modal.component';
import { SbrNexusModal } from 'src/app/components/settings/integrations/services/sbr-nexus-modal/sbr-nexus-modal.component';
import { XbrlrenderserviceModalComponent } from 'src/app/components/settings/integrations/services/xbrlrenderservice-modal/xbrlrenderservice-modal.component';
import { SettingsService } from 'src/app/components/settings/settings.service';
import { OrganisationLayout } from './organisation/organisation.layout';
import { OrganisationUserLayout } from './organisation/users/organisation-user.layout';
import { EditableUserProfileComponent } from './components/editable-user-profile.component';
import { AccountProfilePage } from './account/profile/account-profile.page';
import { OrganisationUserProfilePage } from './organisation/users/profile/organisation-user-profile.page';
import { AccountSignaturePage } from './account/signature/account-signature.page';
import { OrganisationUserSignaturePage } from './organisation/users/signature/organisation-user-signature.page';
import { UserWorkgroupsComponent } from './components/user-workgroups/user-workgroups.component';
import { UserWorkgroupListItemComponent } from './components/user-workgroups/userworkgrouplist/userworkgrouplistitem/userworkgrouplistitem.component';
import { UserWorkgroupListComponent } from './components/user-workgroups/userworkgrouplist/userworkgrouplist.component';
import { UserRolesListComponent } from './components/user-roleandpermissions/user-roles/user-roles-list.component';
import { UserRolesListItemComponent } from './components/user-roleandpermissions/user-roles/user-roles-list-item/user-roles-list-item.component';
import { AccountWorkgroupsPage } from './account/workgroups/account-workgroups.page';
import { OrganisationUserWorkgroupsPage } from './organisation/users/workgroups/organisation-user-workgroups.page';
import { OrganisationUserRolesPermissionsPage } from './organisation/users/roles-permissions/organisation-user-roles-permissions.page';
import { AccountRolesPermissionsPage } from './account/roles-permissions/account-roles-permissions.page';
import { UserRolesPermissionsComponent } from './components/user-roleandpermissions/user-roles-permissions.component';
import { SettingsBreadCrumbService } from './settings-breadcrumb.service';
import { SettingsWhiteLabelOverviewPage } from './whitelabel/overview/settings-whitelabel-overview.page';
import { CreditListComponent } from './components/creditlist/creditlist.component';
import { CreditListItemComponent } from './components/creditlist/creditlistitem/creditlistitem.component';
import { SettingsWhitelabelOrganisationsPage } from './whitelabel/organisations/settings-whitelabel-organisations.page';
import { SettingsApplicationRequestsPage } from './application/requests/settings-application-requests.page';
import { AddressbookPage } from './integrations/addressbook/addressbook.page';
import { IntegrationsDocumentsPage } from './integrations/documents/documents.page';
import { ServicesPage } from './integrations/services/services.page';
import { SettingsOrganisationOverviewPage } from './organisation/overview/settings-organisation-overview.page';
import { PlatformApiPage } from './integrations/platformapi/platformapi.page';
import { ChangeOrganisationModal } from './components/change-organisation/change-organisation.modal';
import { ChangeWhiteLabelModal } from './components/change-whitelabel/change-whitelabel.modal';
import { IdsForSettingsService } from './ids-for-settings.service';
import { SigningChartComponent, OrganisationSigningChartComponent, WhiteLabelSigningChartComponent, SystemSigningChartComponent } from './components/signing-chart/signing-chart.component';
import { BrandingTabColoursComponent, BrandingTabColoursOrganisationComponent, BrandingTabColoursWhiteLabelComponent, BrandingTabColoursSystemComponent } from './components/branding-tab-colours/branding-tab-colours.component';
import { BrandingTabEmailComponent, BrandingTabEmailOrganisationComponent, BrandingTabEmailWhitelabelComponent, BrandingTabEmailSystemComponent } from './components/branding-tab-email/branding-tab-email.component';
import { BrandingTabGeneralComponent, BrandingTabGeneralOrganisationComponent, BrandingTabGeneralWhiteLabelComponent, BrandingTabGeneralSystemComponent } from './components/branding-tab-general/branding-tab-general.component';
import { BrandingTabImagesComponent, BrandingTabImagesWhiteLabelComponent, BrandingTabImagesOrganisationComponent, BrandingTabImagesSystemComponent } from './components/branding-tab-images/branding-tab-images.component';
import { OrganisationStoragePage, StoragePage, WhiteLabelStoragePage, SystemStoragePage } from './storage/storage.page';
import { BrandingPage, OrganisationBrandingPage, WhitelabelBrandingPage, SystemBrandingPage } from './branding/branding.page';
import { SettingsWhiteLabelCreditsPage } from './credits/settings-whitelabel-credits.page';
import { SettingsSystemWhiteLabelProvidersPage } from './system/whitelabelproviders/settings-system-whitelabelproviders.page';
import { SettingsOrganisationCreditsPage } from './credits/settings-organisation-credits.page';
import { WhiteLabelProvidersListComponent } from './system/whitelabelproviders/whitelabelproviderlist/whitelabelproviderslist.component';
import { WhiteLabelProvidersListItemComponent } from './system/whitelabelproviders/whitelabelproviderlist/whitelabelproviderlistitem/whitelabelproviderslistitem.component';
import { SettingsSystemOverviewPage } from './system/overview/settings-system-overview.page';
import { WhiteLabelLayout } from './whitelabel/whiteLabel.layout';
import { DeleteWhiteLabelModal } from './delete-whitelabel/delete-whitelabel.modal';
import { EditWhiteLabelModal } from './edit-whitelabel/edit-whitelabel.modal';
import { SigningMethodsComponent } from './application/signing/signin-methods/signing-methods.component';
import { SettingsOrganisationPermissionsPage } from './permissions/settings-organisation-permissions.page';
import { PermissionsService } from './permissions.service';
import { DisabledByPermissionDirective } from './disabled-by-permission.directive';
import { PermissionWrapperComponent } from './components/permission-wrapper/hide-by-permission-wrapper.component';
import { PermissionedSwitchComponent } from './components/permissioned-switch/permissioned-switch.component';
import { PermissionListComponent } from './components/permissions-list/permission-list.component';
import { ConfigurePermissionComponent } from './components/configure-permission/configure-permission.component';
import { SettingsWhitelabelPermissionsPage } from './permissions/settings-whitelabel-permissions.page';
import { SettingsSystemPermissionsPage } from './permissions/settings-system-permissions.page';
import { CustomUrlsAvatarMenuKnowledgebaseModal } from 'src/app/modals/custom-urls-avatarmenu/custom-urls-avatarmenu-knowledgebase-modal.component';
import { CustomUrlsAvatarMenuReleaseNotesModal } from 'src/app/modals/custom-urls-avatarmenu/custom-urls-avatarmenu-releasenotes-modal.component';
import { CustomUrlsAvatarMenuSupportModal } from 'src/app/modals/custom-urls-avatarmenu/custom-urls-avatarmenu-support-modal.component';
import { ForcePermissionModal } from 'src/app/components/settings/modals/force-permission/force-permission.modal';
import { DeleteUserRequestListComponent } from './delete-user/requestlistitem/app-delete-user-request-list.component';


const authFactory = (openIdConfigService: OpenIdConfigService) => {
  const config = openIdConfigService.getConfig();
  if (isObservable(config)) {
    return new StsConfigHttpLoader(<Observable<OpenIdConfiguration>>config);
  } else {
    return new StsConfigStaticLoader(<OpenIdConfiguration>config);
  }
};

@NgModule({
  declarations: [
    // pages
    //      - Account
    AccountSignaturePage,
    AccountProfilePage,
    AccountWorkgroupsPage,
    AccountRolesPermissionsPage,
    //      - Organisation-User
    OrganisationUserProfilePage,
    OrganisationUserSignaturePage,
    OrganisationUserWorkgroupsPage,
    OrganisationUserRolesPermissionsPage,
    // layouts
    SettingsLayout,
    OrganisationLayout,
    OrganisationUserLayout,
    WhiteLabelLayout,
    // components
    EditableUserProfileComponent,
    UserSignatureComponent,
    UserWorkgroupsComponent,
    UserWorkgroupListComponent,
    UserWorkgroupListItemComponent,
    UserRolesListComponent,
    UserRolesListItemComponent,
    UserRolesPermissionsComponent,
    SigningMethodsComponent,
    PermissionListComponent,
    PermissionWrapperComponent,
    PermissionedSwitchComponent,
    ConfigurePermissionComponent,

    // Pages
    SettingsOrganisationPermissionsPage,
    SettingsWhitelabelPermissionsPage,
    SettingsSystemPermissionsPage,

    // directives
    DisabledByPermissionDirective,

    //Modals
    ChangeOrganisationModal,
    ChangeWhiteLabelModal,
    AddCreditsModal,
    BrandingDisableModal,
    DeleteOrganisationModal,
    DeleteWhiteLabelModal,
    DeleteCreditsModal,
    DeleteWorkgroupModal,
    AddAzureBlobstorageModal,
    DisableAzureBlobstorageModal,
    PrivateWhatsappModal,
    EditOrganisationModal,
    EditWhiteLabelModal,
    DeleteUserModal,
    AddUserModal,
    SimplicateModal,
    ConfigSalesforceModal,
    DigipoortModal,
    SbrNexusModal,
    XbrlrenderserviceModalComponent,
    CustomUrlsAvatarMenuKnowledgebaseModal,
    ForcePermissionModal,
    CustomUrlsAvatarMenuReleaseNotesModal,
    CustomUrlsAvatarMenuSupportModal,

    // unsorted
    SettingsNavigationComponent,
    SettingsOrganisationOverviewPage,
    SettingsOrganisationUsersPage,
    UserListComponent,
    UserListItemComponent,
    SettingsProgressBlockComponent,
    SettingsSubheaderComponent,
    WorkgroupListComponent,
    OrganisationSigningChartComponent,
    SigningChartComponent,
    WorkgroupListItemComponent,
    SettingsOrganisationWorkgroupsPage,
    SettingsOrganisationCreditsPage,
    SettingsWhiteLabelCreditsPage,
    CreditListComponent,
    CreditListItemComponent,
    DeleteMemberWorkgroupComponent,
    AddEditWorkgroupComponent,
    MemberListComponent,
    MemberListItemComponent,
    SettingsAccountSecurityPage,
    SettingsAccountSecurityWebauthnListComponent,
    SettingsAccountSecurityWebauthnListitemComponent,
    SettingsApplicationRequestsPage,
    BrandingPage,
    OrganisationBrandingPage,
    WhitelabelBrandingPage,
    SystemBrandingPage,
    BrandingTabInfoComponent,
    BrandingTabGeneralComponent,
    BrandingTabGeneralOrganisationComponent,
    BrandingTabGeneralWhiteLabelComponent,
    BrandingTabGeneralSystemComponent,
    BrandingTabImagesComponent,
    BrandingTabImagesWhiteLabelComponent,
    BrandingTabImagesOrganisationComponent,
    BrandingTabImagesSystemComponent,
    BrandingTabColoursComponent,
    BrandingTabColoursOrganisationComponent,
    BrandingTabColoursWhiteLabelComponent,
    BrandingTabColoursSystemComponent,
    BrandingTabEmailComponent,
    BrandingTabEmailOrganisationComponent,
    BrandingTabEmailWhitelabelComponent,
    BrandingTabEmailSystemComponent,
    DocumentsPage,
    StationeryListComponent,
    StationeryListItemComponent,
    EnableAuthenticatorAppDialogComponent,
    EnableAuthenticatorAppInfoComponent,
    EnableAuthenticatorAppQrComponent,
    EnableAuthenticatorAppRecoveryCodeComponent,
    EnableSecurityKeyDialogComponent,
    EnableSecurityKeyInfoComponent,
    EnableSecurityKeyReadyComponent,
    DisableDialogComponent,
    PlatformAPISettingComponent,
    ClientOnlineComponent,
    OtherComponent,
    AddressbookPage,
    ServicesPage,
    DigipoortComponent,
    SBRNexusComponent,
    CreditsNotificationComponent,
    EmailPage,
    SigningPage,
    LocationListComponent,
    ReasonListComponent,
    ReasonListItemComponent,
    LocationListItemComponent,
    IntegrationsDocumentsPage,
    OrganisationStoragePage,
    WhiteLabelStoragePage,
    SystemStoragePage,
    GeneralPage,
    IdentityPage,
    SsoPage,
    ValidationPage,
    SettingsWhitelabelOrganisationsPage,
    OrganisationListComponent,
    OrganisationListItemComponent,
    SettingsSystemWhiteLabelProvidersPage,
    WhiteLabelProvidersListComponent,
    WhiteLabelProvidersListItemComponent,
    ClientOnlineSettingsComponent,
    PlatformAPIModal,
    PlatformApiPage,
    SettingsWhiteLabelOverviewPage,
    SettingsSystemOverviewPage,
    WhiteLabelSigningChartComponent,
    SystemSigningChartComponent,
    SigningChartComponent,
    StoragePage,
    DeleteUserRequestListComponent
  ],

  imports: [
    CommonModule,
    SettingsRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [OpenIdConfigService],
      }
    }),
    QRCodeModule
  ],
  providers: [SettingsService, IdsForSettingsService, SettingsBreadCrumbService, PermissionsService],
  bootstrap: [AppComponent]
})
export class SettingsModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

